<template>
  <div
    v-if="!!contacts.length"
    data-cy="contacts-list"
    class="flex max-h-125 flex-col space-y-3 overflow-y-auto"
  >
    <contact-list-item
      v-for="(contact, index) in contacts || []"
      :key="contact.id"
      :contact="contact"
      :deal="deal"
      :id="id"
      :index-position="index"
    />
  </div>
  <div v-else data-cy="empty-contacts" class="text-md p-2 text-label">
    <p>{{ $t("ACTIVITY.CONTACTS.NO_CONTACTS_ARE_AVAILABLE") }}</p>
  </div>
</template>

<script lang="ts" setup>
import ContactListItem from "@/views/deals/components/contacts/ContactListItem.vue";

import type {
  ApplicationWithContactData,
  IApplication,
} from "@/models/applications";
import type { ContactTelephones } from "@/models/communicationLogs";
import type { PropType } from "vue";

defineProps({
  contacts: {
    required: true,
    type: Array as PropType<ContactTelephones[]>,
  },
  id: {
    required: true,
    type: String,
  },
  deal: {
    type: Object as PropType<ApplicationWithContactData | IApplication>,
    required: true,
  },
});
</script>
